/**
 * Utility functions for preloading lazy-loaded components
 * to improve perceived performance
 */

// Preload functions for lazy components
export const preloadDashboardPages = () => {
  // Preload dashboard pages when user is likely to navigate to them
  return Promise.all([
    import('../pages/dashboard/MyCalendar'),
    import('../pages/dashboard/Bookings'),
    import('../pages/dashboard/ShiftNotes'),
    import('../pages/dashboard/ManagePlan'),
  ])
}

export const preloadPublicProfile = () => {
  // Preload public profile page
  return import('../pages/public/CaregiverProfile')
}

// Preload specific components based on user actions
export const preloadCalendar = () => import('../pages/dashboard/MyCalendar')
export const preloadBookings = () => import('../pages/dashboard/Bookings')
export const preloadShiftNotes = () => import('../pages/dashboard/ShiftNotes')
export const preloadManagePlan = () => import('../pages/dashboard/ManagePlan')
export const preloadCaregiverProfile = () => import('../pages/public/CaregiverProfile')

/**
 * Preload components when user hovers over navigation links
 * This provides instant navigation when they actually click
 */
export const setupPreloadOnHover = () => {
  // This can be called in the dashboard layout to set up hover preloading
  const preloadMap: Record<string, () => Promise<any>> = {
    '/dashboard/calendar': preloadCalendar,
    '/dashboard/bookings': preloadBookings,
    '/dashboard/shift-notes': preloadShiftNotes,
    '/dashboard/manage-plan': preloadManagePlan,
  }

  // Add event listeners to navigation links
  Object.entries(preloadMap).forEach(([path, preloadFn]) => {
    const links = document.querySelectorAll(`a[href="${path}"]`)
    links.forEach(link => {
      let preloaded = false
      link.addEventListener('mouseenter', () => {
        if (!preloaded) {
          preloadFn()
          preloaded = true
        }
      })
    })
  })
}

/**
 * Preload components based on user authentication state
 */
export const preloadForAuthenticatedUser = () => {
  // When user logs in successfully, preload dashboard components
  return preloadDashboardPages()
}

/**
 * Preload components when user is on onboarding
 */
export const preloadForOnboardingUser = () => {
  // When user is in onboarding, preload dashboard for when they complete
  setTimeout(() => {
    preloadDashboardPages()
  }, 2000) // Delay to not interfere with onboarding performance
}
